/**
 * Rend une adresse de couverture Drive directement servable.
 *
 * ## ⚠️ `drive.google.com/thumbnail` n'est pas le CDN, c'est un aiguillage
 *
 * Mesuré le 2026-09-02, huit appels d'affilée sur chaque adresse :
 *
 *   · `drive.google.com/thumbnail?id=…&sz=w760`  → **302, 302, 302…** à chaque fois
 *   · `lh3.googleusercontent.com/d/…=w760`       → **200, sans redirection**
 *
 * Le premier ne sert jamais l'image : il redirige vers le second. Chaque
 * couverture coûtait donc un aller-retour de plus, sur un point d'entrée que
 * Google limite en débit. Sur une grille qui en charge quatre d'un coup et un
 * réseau mobile hésitant, l'une d'elles tombe — c'est ce que Baptiste a vu le
 * 2026-09-02, avec la même couverture parfaitement visible sur son ordinateur.
 *
 * ⚠️ **La transformation se fait à l'affichage, pas en base.** Les adresses
 * stockées restent celles que le formateur a collées, et c'est ce qu'il faut :
 * elles viennent de ce que Drive lui montre quand il partage un fichier. Les
 * réécrire en base l'obligerait à reconnaître une forme d'adresse qu'il n'a
 * jamais tapée, et la prochaine collée repartirait de travers.
 */
export function couvertureDirecte(url: string): string {
  if (!url.includes('drive.google.com/thumbnail')) return url

  try {
    const adresse = new URL(url)
    const id = adresse.searchParams.get('id')
    if (!id) return url
    /* `sz` est facultatif chez Drive ; sans lui, le CDN sert la taille d'origine,
       ce qui reste juste — seulement plus lourd. */
    const taille = adresse.searchParams.get('sz')
    return `https://lh3.googleusercontent.com/d/${id}${taille ? `=${taille}` : ''}`
  } catch {
    /* Une adresse illisible n'est pas réécrite : mieux vaut la laisser échouer
       telle quelle que la transformer en autre chose d'aussi faux. */
    return url
  }
}
